import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["error", "name", "className", "title", "titleCenter", "caption", "required", "value"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef, useEffect, useRef } from "react";
import classnames from "classnames";
import HiddenField from "./HiddenField";
import styles from "@/styles/Form.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var ReadOnlyField = /*#__PURE__*/forwardRef(function (props, ref) {
  var _classnames;

  var error = props.error,
      name = props.name,
      className = props.className,
      title = props.title,
      titleCenter = props.titleCenter,
      caption = props.caption,
      required = props.required,
      value = props.value,
      _props = _objectWithoutProperties(props, _excluded);

  var input = useRef();
  useEffect(function () {
    if (input.current) {
      input.current.value = value;
    }
  }, [value]);
  return /*#__PURE__*/_jsxs("div", {
    className: styles.inputField,
    children: [title && /*#__PURE__*/_jsx("legend", {
      className: classnames(styles.formTitle, (_classnames = {}, _defineProperty(_classnames, styles.center, titleCenter), _defineProperty(_classnames, styles.required, required), _classnames)),
      children: title
    }), /*#__PURE__*/_jsx("input", _objectSpread({
      ref: input,
      type: "text",
      name: name,
      className: classnames(styles.textInput, className),
      defaultValue: "",
      tabIndex: "-1",
      disabled: true,
      readOnly: true
    }, _props)), /*#__PURE__*/_jsx(HiddenField, {
      ref: ref,
      name: name,
      value: value
    }), caption && /*#__PURE__*/_jsx("p", {
      className: styles.caption,
      children: caption
    }), error && /*#__PURE__*/_jsx("span", {
      className: styles.errorMessage,
      children: error
    })]
  });
});
ReadOnlyField.displayName = "ReadOnlyField";
export default ReadOnlyField;